<template>
  <b-col class="col-sm-6 col-lg-3">
    <a
      :href="quickaccess.url"
      class="card"
    >
      <b-img-lazy
        class="cardIcon"
        :src="quickaccess.image_url"
        alt="image"
      />
      <div class="card-body">
        <button style="top: 95%">{{ quickaccess.name }}</button>
      </div>
    </a>
  </b-col>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'QuickAccessElements',
  data () {
    return {
      quickAccessId: parseInt(this.$vnode.key)
    }
  },
  computed: {
    ...mapGetters([
      'getStoredQuickAccessById'
    ]),
    quickaccess () {
      return this.getStoredQuickAccessById(this.quickAccessId)
    }
  }
}
</script>

<style scoped>
.card {
  max-width: 200px;
  max-height: 200px;
  min-height: 100px;
  min-width: 100px;
  margin: 20px auto 0;
  border: none;
  background: transparent;
}

.card button {
  background: transparent;
  color: #007bff !important;
  border: white 0 solid;
  padding: 4px 16px;
  font-weight: 500;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  font-size: 24px;
}

.cardIcon {
  width: 100%;
  height: 170px;
  object-fit: cover;
  background-repeat: no-repeat;
  background-size: cover;
  z-index: 1;
}
</style>
